/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { HashRouter as Router } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { loadAgencyProfile } from "../../actions/agencyProfileActions";
import ActionBar from "../shared/general/ActionBar";
import FullScreenLoading from "../shared/loaders/FullScreenLoading";
import AgencyMessage from "./AgencyMessage";
import CompletionWidget from "./CompletionWidget";
import ImageSlider from "./ImageSlider";
import User from "./User";
import CompanyPerformance from "./CompanyPerformance";
import CompanySpecialities from "./CompanySpecialities";
import EngagementsPlacements from "./EngagementsPlacements";
import CandidateQualification from "./CandidateQualification";
import AboutAgent from "./AboutAgent";
import CandidateQualificationModal from "./CandidateQualificationModal";
import AboutAgentModal from "./AboutAgentModal";
import AboutCompanyModal from "./AboutCompanyModal";
import EngagementsPlacementsModal from "./EngagementsPlacementsModal";
import RejectModal from "./RejectModal";
import PerformanceInfoModal from "./PerformanceInfoModal";
import Tabs from "./Tabs";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import {
  Wrapper,
  Inner,
  UserAndPerformance,
} from "./styles/agency-profile-styles";

export class AgencyProfile extends Component {
  state = {
    qualificationModalActive: false,
    agentAboutModalActive: false,
    companyAboutModalActive: false,
    engagementsPlacementsModalActive: false,
    rejectModalActive: false,
    performanceModalActive: false,
    backTo: null,
  };

  componentDidMount() {
    const { loadAgencyProfile, recruiterUserId, engagementId } = this.props;
    const backTo = new URLSearchParams(window.location.search).get("back_to");

    this.setState({ backTo });
    loadAgencyProfile({ recruiterUserId, engagementId });
  }

  toggleQualificationModal = () => {
    this.setState(({ qualificationModalActive }) => ({
      qualificationModalActive: !qualificationModalActive,
    }));
  };

  toggleEngagementsPlacementsModal = () => {
    this.setState(({ engagementsPlacementsModalActive }) => ({
      engagementsPlacementsModalActive: !engagementsPlacementsModalActive,
    }));
  };

  toggleAboutAgentModal = () => {
    this.setState(({ agentAboutModalActive }) => ({
      agentAboutModalActive: !agentAboutModalActive,
    }));
  };

  toggleAboutCompanyModal = () => {
    this.setState(({ companyAboutModalActive }) => ({
      companyAboutModalActive: !companyAboutModalActive,
    }));
  };

  toggleRejectModal = () => {
    this.setState(({ rejectModalActive }) => ({
      rejectModalActive: !rejectModalActive,
    }));
  };

  togglePerformanceInfoModal = () => {
    this.setState(({ performanceModalActive }) => ({
      performanceModalActive: !performanceModalActive,
    }));
  };

  render() {
    const {
      qualificationModalActive,
      agentAboutModalActive,
      companyAboutModalActive,
      engagementsPlacementsModalActive,
      rejectModalActive,
      performanceModalActive,
      backTo,
    } = this.state;
    const {
      loading,
      profileData,
      engagementId,
      engagementActionTaken,
      adminManagedEngagements,
    } = this.props;
    return (
      <ErrorBoundary>
        <ActionBar
          title={profileData && profileData.user.companyName}
          mobileTitle={profileData && profileData.user.companyName}
          loading={loading}
          backLinkUrl={backTo}
          backLink={
            profileData && profileData.currentUser.isEmployer ? "Back" : ""
          }
          mobileBackButton={profileData && !profileData.currentUser.isRecruiter}
        />
        {loading ? (
          <FullScreenLoading />
        ) : (
          <Wrapper>
            <Router>
              <ReactTooltip
                place="bottom"
                type="dark"
                effect="solid"
                aria-haspopup="true"
                id="agency-profile-tooltip"
              />
              <Inner>
                {profileData &&
                  profileData.currentUser.isEmployer &&
                  engagementId && (
                    <Fragment>
                      {!profileData.engagement.engagementRespondedTo &&
                        !engagementActionTaken &&
                        profileData.engagementMessageData && (
                          <AgencyMessage
                            employerUserId={profileData.currentUser.id}
                            engagementId={engagementId}
                            jobId={profileData.engagement.jobId}
                            toggleRejectModal={this.toggleRejectModal}
                            adminManagedEngagements={adminManagedEngagements}
                          />
                        )}
                      {!adminManagedEngagements && rejectModalActive && (
                        <RejectModal
                          jobId={profileData.engagement.jobId}
                          engagementId={engagementId}
                          employerUserId={profileData.currentUser.id}
                          toggleRejectModal={this.toggleRejectModal}
                        />
                      )}
                    </Fragment>
                  )}
                {profileData &&
                  profileData.currentUser.isRecruiter &&
                  profileData.currentUser.isAdmin && <CompletionWidget />}
                {performanceModalActive && (
                  <PerformanceInfoModal
                    togglePerformanceInfoModal={this.togglePerformanceInfoModal}
                  />
                )}
                <ImageSlider />
                <UserAndPerformance>
                  <User />
                  <CompanyPerformance
                    togglePerformanceInfoModal={this.togglePerformanceInfoModal}
                  />
                </UserAndPerformance>
                <CompanySpecialities />
                <EngagementsPlacements
                  toggleEngagementsPlacementsModal={
                    this.toggleEngagementsPlacementsModal
                  }
                />
                {engagementsPlacementsModalActive && (
                  <EngagementsPlacementsModal
                    toggleEngagementsPlacementsModal={
                      this.toggleEngagementsPlacementsModal
                    }
                  />
                )}
                <CandidateQualification
                  toggleQualificationModal={this.toggleQualificationModal}
                />
                {qualificationModalActive && (
                  <CandidateQualificationModal
                    toggleQualificationModal={this.toggleQualificationModal}
                  />
                )}
                <AboutAgent
                  toggleAboutAgentModal={this.toggleAboutAgentModal}
                />
                {agentAboutModalActive && (
                  <AboutAgentModal
                    toggleAboutAgentModal={this.toggleAboutAgentModal}
                  />
                )}
                {companyAboutModalActive && (
                  <AboutCompanyModal
                    toggleAboutCompanyModal={this.toggleAboutCompanyModal}
                  />
                )}
                <Tabs
                  toggleAboutCompanyModal={this.toggleAboutCompanyModal}
                  companyName={profileData.user.companyName}
                  companyId={profileData.user.companyId}
                />
              </Inner>
            </Router>
          </Wrapper>
        )}
      </ErrorBoundary>
    );
  }
}

AgencyProfile.propTypes = {
  loadAgencyProfile: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  recruiterUserId: PropTypes.number.isRequired,
  engagementId: PropTypes.number,
  adminManagedEngagements: PropTypes.bool,
  profileData: PropTypes.shape({
    user: PropTypes.shape({
      companyId: PropTypes.number,
      companyName: PropTypes.string,
      isRecruiter: PropTypes.bool,
    }),
    engagement: PropTypes.shape({
      engagementRespondedTo: PropTypes.bool,
      jobId: PropTypes.number,
    }),
    currentUser: PropTypes.shape({
      id: PropTypes.string.isRequired,
      isEmployer: PropTypes.bool.isRequired,
      isRecruiter: PropTypes.bool.isRequired,
    }),
    engagementMessageData: PropTypes.shape({
      agentName: PropTypes.string,
      agencyName: PropTypes.string,
      message: PropTypes.string,
      avatar: PropTypes.string,
    }),
  }),
  engagementActionTaken: PropTypes.bool.isRequired,
};

AgencyProfile.defaultProps = {
  profileData: PropTypes.isNull,
  engagementId: PropTypes.isNull,
  adminManagedEngagements: false,
};

const mapStateToProps = (state) => ({
  loading: state.agencyProfile.loading,
  profileData: state.agencyProfile.profileData,
  engagementActionTaken: state.agencyProfile.engagementActionTaken,
});

export default connect(mapStateToProps, { loadAgencyProfile })(AgencyProfile);
